import { get, find, sortBy, map } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import TextEditorButton from './text-editor-button';
import TextEditorDropdown from './text-editor-dropdown';
import styles from './text-editor-dropdown-button.scss';

class TextEditorDropdownButton extends Component {
  static propTypes = {
    buttons: PropTypes.array.isRequired,
    isActive: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    cardBackgroundColor: PropTypes.string,
    isInverted: PropTypes.bool,
    className: PropTypes.string,
    theme: PropTypes.object,
  };

  state = {};

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentMouseDown, true);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentMouseDown, true);
  }

  getFirstButton = () => find(this.props.buttons, ({ value }) => this.props.isActive(value)) || this.props.buttons[0];

  getDropdownButtons = () => {
    const firstButtonValue = this.getFirstButton().value;
    return sortBy(this.props.buttons, ({ value }) => (value === firstButtonValue ? 0 : 1));
  };

  handleTriggerClick = () => {
    this.setState({
      isVisible: true,
      height: findDOMNode(this).offsetHeight,
    });
  };

  handleDocumentMouseDown = event => {
    const node = findDOMNode(this);
    if (!node.contains(event.target)) {
      this.setState({
        isVisible: false,
      });
    }
  };

  renderButton({ value, icon, tooltipText, className }, buttonProps) {
    const { isActive, onClick } = this.props;
    const handleClick = () => {
      onClick(value);
      this.setState({
        isVisible: false,
      });
    };
    return (
      <TextEditorButton
        isActive={isActive(value)}
        onClick={handleClick}
        icon={icon}
        tooltipText={tooltipText}
        className={className}
        {...buttonProps}
      />
    );
  }

  renderDropdown(buttonProps) {
    const { isVisible } = this.state;
    const { isInverted, theme } = this.props;

    if (!isVisible) {
      return null;
    }
    return (
      <TextEditorDropdown itemHeight={this.state.height} isInverted={isInverted} theme={get(theme, 'dropdown')}>
        {map(this.getDropdownButtons(), (button, key) =>
          this.renderButton(button, {
            ...buttonProps,
            key,
          })
        )}
      </TextEditorDropdown>
    );
  }

  render() {
    const {
      isActive, // eslint-disable-line no-unused-vars
      onClick, // eslint-disable-line no-unused-vars
      className,
      ...buttonProps
    } = this.props;
    const button = this.renderButton(this.getFirstButton(), {
      ...buttonProps,
      onClick: this.handleTriggerClick,
    });

    return (
      <div className={classNames(styles.container, className)}>
        {button}
        {this.renderDropdown(buttonProps)}
      </div>
    );
  }
}

export default TextEditorDropdownButton;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-dropdown-button.js